import { _ as _define_property } from "@swc/helpers/_/_define_property";
import dayjs from "dayjs";
var _obj;
export var initStateDoData = (_obj = {
    fact_new_so_id: "",
    dim_mst_do_status_id: "",
    dim_mst_payment_type_id: "",
    dim_mst_price_category_id: "",
    dim_new_alldernow_emp_id: "",
    fact_member_id: "",
    doc_number: "",
    so_doc_number_ref: "",
    full_member_name: "",
    full_member_address_name: "",
    member_is_hq: "",
    member_branch_no: "",
    member_additional_info: "",
    member_business_type: "",
    member_customer_type: "",
    member_address: "",
    member_district: "",
    member_amphoe: "",
    member_province: "",
    member_postal_code: "",
    member_phone_number: "",
    dim_warehouse_id: 3,
    dim_branch_id: 3,
    refer: "",
    dim_mst_discount_type_id: 1,
    discount_value: 0.0,
    total_price_before_discount: 0,
    discount_price: 0.0,
    total_price_after_discount: 0,
    total_price_product_no_vat: 0,
    total_price_product_zero_vat: 0,
    total_price_product_seven_vat: 0,
    total_seven_vat_amount: 0,
    total_price_vat: 0,
    total_price_before_vat: 0,
    grand_total_price: 0,
    sum_item_quantity: 0,
    sum_item_so_quantity: 0,
    remark: "",
    doc_issue_date: dayjs().format("YYYY-MM-DD"),
    delivery_date: "",
    is_sort_manual: true,
    is_ready_to_delivery: false,
    is_receive_point: false,
    updated_success_delivery_time: "",
    canceled_at: "",
    canceled_by_emp_id: "",
    updated_wait_approve_at: "",
    updated_approve_at: "",
    ready_to_delivery_date: ""
}, _define_property(_obj, "member_address", ""), _define_property(_obj, "is_delivery_success", true), _define_property(_obj, "delivered_success_date", ""), _define_property(_obj, "updated_success_delivery_at", ""), _obj);
